import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { Header } from './Header';
import { PullToRefresh } from './PullToRefresh';
import { InvitationPromptDialog } from '@/components/sharing/InvitationPromptDialog';
import { UnassignedSpendingPromptDialog } from '@/components/spending/UnassignedSpendingPromptDialog';
import { PushInstallNudge } from '@/components/push/PushInstallNudge';
import { useSync } from '@/contexts/SyncContext';
import { cn } from '@/lib/utils';

export function MainLayout() {
  const { isOnline, pendingChanges, status } = useSync();
  const isSyncing = status === 'syncing';
  // Share invites first, then unassigned spending — so accepted budgets are available to assign into.
  const [invitationPromptOpen, setInvitationPromptOpen] = React.useState(false);

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />

      {/* Offline-only connection signal (no persistent online indicator) */}
      {!isOnline && (
        <div
          role="status"
          className="flex items-center justify-center gap-2 bg-warning px-4 py-2 text-center text-sm text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            className="shrink-0"
          >
            <line x1="1" x2="23" y1="1" y2="23" />
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
            <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
            <line x1="12" x2="12.01" y1="20" y2="20" />
          </svg>
          <span>You're offline. Changes will sync when you reconnect.</span>
        </div>
      )}

      {isOnline && isSyncing && (
        <div className="bg-primary/10 px-4 py-1.5 text-center text-xs text-primary">
          Syncing {pendingChanges} change{pendingChanges !== 1 ? 's' : ''}...
        </div>
      )}

      <PushInstallNudge />

      <PullToRefresh className="flex flex-1 flex-col">
        <main
          className={cn(
            'flex min-w-0 flex-1 flex-col pb-bottom-nav',
            'container mx-auto max-w-2xl md:max-w-7xl px-4 pt-4'
          )}
        >
          <Outlet />
        </main>
      </PullToRefresh>

      <BottomNav />

      <InvitationPromptDialog onOpenChange={setInvitationPromptOpen} />
      <UnassignedSpendingPromptDialog holdOff={invitationPromptOpen} />
    </div>
  );
}
